import React from 'react';
import styles from './BackdropSpinner.module.css';

const BackdropSpinner = ({spinnerState}) => (
    <div className={styles.BackdropSpinner} data-testid="BackdropSpinner">
        <div className={`${spinnerState && spinnerState.length > 0 ? styles.coverSpin : "coverSpin hidden"}`}>
            <div data-testid="SpinnerMessages" className={styles.messages}>
                {spinnerState.map(s => {
                    return <div key={s.id}>{s.message}</div>
                })}
            </div>
        </div>
    </div>
);

export default BackdropSpinner;
